import React, { PureComponent } from 'react';

import { getText } from '../../helpers';

class None extends PureComponent {
  render(){
    return <span><u>{getText("None")}</u></span>
  }
}

class Read extends PureComponent {
  render(){
    return <span className="blue-text"><u>{getText("View")}</u></span>
  }
}

class Update extends PureComponent {
  render(){
    return <span className="red-text"><u>{getText("Edit")}</u></span>
  }
}

export default class ToggleColumnCell extends PureComponent {
  render(){
    const { className, onClick, permission } = this.props
    return <div className={className} onClick={onClick}>
      {permission.can_update ? <Update/> :
        (permission.can_read ? <Read/> : <None/> ) }
      </div>
  }
}



// WEBPACK FOOTER //
// ./src/components/userPlanPermissionTable/toggleColumnCell.js